import * as React from 'react';
import {FormattedMessage} from "react-intl";
import {Alert, Button, Divider, Typography} from "@mui/material";
import "../self-terminal.css";
import "./index.css";
import {Language} from "../../../../modules/common/enums/Language";
import {useContext, useEffect, useState} from "react";
import {LanguageContext} from "../../../../context/LanguageContext";
import VisitCodeInputDialog from "./components/VisitCodeInputDialog";
import {RequestVisitorDto} from "../../../../modules/vms/dto/RequestVisitorDto";
import CheckinDialog from "./components/CheckinDialog";
import {VisitRequestClassify} from "../../../../modules/vms/enums/VisitRequestClassify";
import RegistrationDialog from "./components/RegistrationDialog";
import CheckIcon from '@mui/icons-material/Check';
import {RequestVisitorApi} from "../../../../modules/vms/api/RequestVisitorApi";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";

// 扫码枪用到的变量
let code = "";
let lastTime = 0;
let nextTime = 0;
let lastCode = 0;
let nextCode = 0;

export default function Index() {

    // 多语言上下文设置
    const {language, setLanguage} = useContext(LanguageContext);
    const [openVisitCodeDialog, setOpenVisitCodeDialog] = useState(false);
    const [openCheckinDialog, setOpenCheckinDialog] = useState(false);
    const [openRegistrationDialog, setOpenRegistrationDialog] = useState(false);
    const [requestVisitor, setRequestVisitor] = useState<RequestVisitorDto>(new RequestVisitorDto());
    const [isPortrait, setIsPortrait] = useState(false);

    useEffect(() => {
        // 判断是否是竖屏
        const isPortrait = window.matchMedia("(orientation: portrait)").matches;
        setIsPortrait(isPortrait);

        // 监听键盘事件以实现扫码直接签到
        window.addEventListener('keypress', _handleScanWrapper, false);

        return() => {
            window.removeEventListener('keypress', _handleScanWrapper, false);
        }
    }, []);

    const _handleScanWrapper = (e:KeyboardEvent) => {
        console.log(e);
        // e.which拿到的是keyCode
        nextCode = e.which;
        nextTime = new Date().getTime();

        if (lastCode != null && lastTime != null && nextTime - lastTime <= 30) {
            //时间短为扫码枪
            code += String.fromCharCode(lastCode);
        } else if (lastCode != null && lastTime != null && nextTime - lastTime > 100) {
            //普通手动键盘输入
            code = "";
        }
        // console.log(code);

        lastCode = nextCode;
        lastTime = nextTime;
        //是否点击Enter键
        if (e.which === 13) {
            // code = "2ca0e63fc95b47c99c196835e009b93d";
            // 因为回车符不是""，会导致后台服务被调用，所以加上trim方法过滤掉再判断
            if (code !== "" && code.trim().length > 0) {
                _handleVerify(code);
            }
            //清空code
            code = "";
        }
    }

    const _handleVerify = async (visitCode:string) => {
        if (visitCode) {
            const responseResult = await RequestVisitorApi.getAvailableVisitor(visitCode);
            if (responseResult.status === HttpStatus.SUCCESS) {
                _handleVisitCodeVerified(responseResult.data);
            }
        }
    }

    const _handleChangeLanguage = (value: string) => {
        setLanguage(value);
    }

    const _handleVisitCodeVerified = (requestVisitor: RequestVisitorDto) => {
        setRequestVisitor(requestVisitor);
        setOpenCheckinDialog(true);
    }

    return (
        <div className="self-terminal-page">
            <VisitCodeInputDialog open={openVisitCodeDialog}
                                  onVerified={(requestVisitor) => _handleVisitCodeVerified(requestVisitor)}
                                  onClose={() => setOpenVisitCodeDialog(false)}/>
            <CheckinDialog open={openCheckinDialog} requestVisitor={requestVisitor}
                           visitorClassify={requestVisitor.visitRequest?.classify || VisitRequestClassify.Enum.Visitor}
                           onClose={() => setOpenCheckinDialog(false)}/>
            <RegistrationDialog open={openRegistrationDialog} onClose={() => setOpenRegistrationDialog(false)}/>
            <div className="self-terminal-page-welcome-container">
                <div
                    className={isPortrait ? "self-terminal-page-welcome-content-portrait" : "self-terminal-page-welcome-content"}>
                    {/*VMS标题*/}
                    <div className="welcome-header">
                        <img alt={'matrix-vms'} className={"welcome-header-logo"} src={'/logo.png'}/>
                        <div className={"welcome-header-title"}>
                            <FormattedMessage id='VMS_TERMINAL_WELCOME_TITLE'/>
                        </div>
                    </div>
                    {/*<div className="line-layer flex-col"/>*/}
                    <div className="welcome-operation-panel ">
                        <div className={"welcome-operation-main"}>
                            <Button variant="contained" style={{height: '10vh'}}
                                    onClick={() => setOpenVisitCodeDialog(true)}>
                                <FormattedMessage id='VMS_TERMINAL_WELCOME_SIGN_IN_ZH'/><br/>
                                <FormattedMessage id='VMS_TERMINAL_WELCOME_SIGN_IN_EN'/>
                            </Button>
                            <Button variant="contained" style={{height: '10vh'}}
                                    onClick={() => setOpenRegistrationDialog(true)}>
                                <FormattedMessage id='VMS_TERMINAL_WELCOME_REGISTER_ZH'/><br/>
                                <FormattedMessage id='VMS_TERMINAL_WELCOME_REGISTER_EN'/>
                            </Button>
                        </div>

                        {/*<div className="welcome-operation-sub">*/}
                        {/*<Button variant="contained"*/}
                        {/*        onClick={() => this.props.router.push(VMSRoutePath.VMS_TERMINAL_REQUEST_CREATE_VEHICLE)}*/}
                        {/*> <FormattedMessage id='VMS_TERMINAL_WELCOME_BUTTON_CAR_CHECK_IN'/></Button>*/}

                        {/*</div>*/}
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <div style={{width: '100%', marginLeft: 'auto', marginRight: 'auto'}}>
                            <Alert icon={<CheckIcon fontSize="inherit"/>} severity="success">
                                <FormattedMessage id={'VMS_TERMINAL_WELCOME_SIGN_IN_SCAN_HELP'}/>
                            </Alert>
                        </div>
                        <div className='welcome-language-panel'>

                            <div className="layer flex-row">
                                <div className="left-line flex-col"/>
                                <div className="select-text">选择语言 / Language&nbsp;selection</div>
                                <div className="right-line flex-col"/>
                            </div>

                            <div className="welcome-language-button-panel">
                                <Button variant="contained" onClick={() => _handleChangeLanguage(Language.Enum.enUS)}>
                                    <FormattedMessage id={Language.Map.get("en-US")}/>
                                </Button>
                                <Button variant="contained" onClick={() => _handleChangeLanguage(Language.Enum.zhCN)}>
                                    <FormattedMessage id={Language.Map.get("zh-CN")}/>
                                </Button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}